var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-document-item-table"},[(!!_vm.data.setting.title)?_c('h2',[_vm._v(_vm._s(_vm.data.setting.title))]):_vm._e(),_c('link-document-markdown',{attrs:{"value":_vm.data.text}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }